import { FirestoreDataConverter as AdminFirestoreDataConverter, DocumentData } from 'firebase-admin/firestore';

import { FirestoreDataConverter, SetOptions } from '@angular/fire/firestore';

export type FirestoreNestedConverter<T> = {
  toFirestore?: (model: T | DocumentData) => T;
  fromFirestore?: (model: T) => T;
}

export type FirestoreConverter<T> = AdminFirestoreDataConverter<T> & 
FirestoreDataConverter<T>

export const withNestedConverter = <T>(firestoreConverter: FirestoreConverter<T>) => {
  return (nestedConverter: FirestoreNestedConverter<T> = {}): FirestoreConverter<T> => ({
    toFirestore(documentData: T, options?: SetOptions) {
      const convertedData = firestoreConverter.toFirestore(documentData, options);

      if (nestedConverter.toFirestore) {
        return nestedConverter.toFirestore(convertedData);
      }
  
      return convertedData;
    },
    fromFirestore(snapshot) {
      const convertedData = firestoreConverter.fromFirestore(snapshot);

      if (nestedConverter.fromFirestore) {
        return nestedConverter.fromFirestore(convertedData);
      }
  
      return convertedData;
    },
  })
};